import React, { Fragment } from 'react'

const Consultation = () => {
    return (
        <Fragment>
            <h2>Web Presence Consultation</h2>
            <p>
                We believe the first step in running a successful business is
                creating a plan around customers and products and services. As
                business owners, we take pride in offering the best service for
                our clients. We start by putting ourselves in a position where
                we can understand the needs of the business. Before we can take
                your business to the next level online, we take your problems as
                our problems and create solutions around those problems.
            </p>
            <p>Our Web Presence Consultation has a few components built in:</p>
            <ul>
                <li>
                    <h4>Business analysis in relation to the internet</h4>
                    <p>
                        A full analysis of the day to day interaction between
                        current avenues of electronic communication including
                        social media, SaaS connection, and other forms of online
                        marketing
                    </p>
                </li>
                <li>
                    <h4>Gaps in your current state of your web presence</h4>
                    <p>
                        Are there any avenues of online marketing not being
                        used? If so, are any of these areas a viable asset. We
                        want to help bring these avenues to your attention and
                        if they are worth bringing into your business. Let's
                        create a plan in these areas where you can control these
                        features and bring more customer awareness to your
                        business.
                    </p>
                </li>
                <li>
                    <h4>Success and Losses</h4>
                    <p>
                        We want to know what you've tried, what has worked and
                        what has not. With the help of our business networking
                        group, we get access to see what other business are
                        doing to grow business. If a previous execution didn't
                        work, was it the timing, the execution, or was this
                        actually a method that doesn't work for your business
                        model. If there was a success in your business, your
                        input would help bring value in the next iteration.
                    </p>
                </li>
            </ul>
            <h3>Outcome</h3>
            <p>
                With a new view of what the internet can do for your business
                and what value you can bring to your customers, we expect to
                bring information that will help you make informed business
                decisions when it comes to your business's web presence. With
                this information, we will guide you down the path on your next
                solution, whether it is the creation of a new website or
                application, or providing a redesign format for your existing
                web utilities.
            </p>
        </Fragment>
    )
}

export default Consultation
